import { Paper, TextField, Button } from '@mui/material';
import { useLanguage } from '../../context/LanguageContext';
import "../../assets/style/Security.css"

export default function ChangePasswordForm() {
  const { t } = useLanguage();
  return (
    <Paper elevation={0} className="card security-card change-password-card">
      <form>
        <div className="form-fields-column">
          <TextField label={t('oldPassword')} type="password" variant="outlined" fullWidth className="custom-textfield" />
          <TextField label={t('newPassword')} type="password" variant="outlined" fullWidth className="custom-textfield" />
          <TextField label={t('newPasswordConfirm')} type="password" variant="outlined" fullWidth className="custom-textfield" />
        </div>
        <div className="form-actions">
          <Button variant="contained" className="action-button" >{t('changePassword')}</Button>
        </div>
      </form>
    </Paper>
  );
}